import { connect } from 'react-redux';

import { collections as collectionsDuck } from '@eb/destination-utils';

import {
    clickOnViewEvent,
    clickOnSeeMore,
    clickOnSaveEvent,
    clickOnShareEvent,
    clickOnOnboardingCard,
} from '../redux/events/actions';
import { GA_HOME_FEED_CATEGORY } from '../constants/analytics';
import EventsBucket from '../components/EventsBucket';

const {
    actions: {
        addOrRemoveEventToCollection: addOrRemoveEventToCollectionAction,
        createCollection: createCollectionAction,
    },
    selectors: { getFormattedCollections },
} = collectionsDuck;

const _mapStateToProps = (state) => ({
    isMobile: state.app.isMobile,
    isAuthenticated: state.user.isAuthenticated,
    searchCriteria: state.content.flatBucket
        ? state.content.flatBucket.eventSearch
        : { dates: ['current_future'] },
    locationSlug: state.location.slug,
    currentPlace: state.location.currentPlace,
    userCollections: state.app.featureFlags.enableUserCollections
        ? getFormattedCollections(state)
        : undefined,
    shouldShowOnboardingEntryPoint:
        state.app.featureFlags.shouldShowOnboardingEntryPoint,
    tabKey: state.content.browseState.tabKey,
    userId: state.user.publicId,
    shareOptions: state.shareOptions || {},
    seasonalContent: state.content.seasonal,
});

const _mapDispatchToProps = {
    onViewEvent: clickOnViewEvent,
    onSeeMore: clickOnSeeMore,
    onSaveEvent: clickOnSaveEvent,
    onAddOrRemoveEventToCollection: addOrRemoveEventToCollectionAction(
        GA_HOME_FEED_CATEGORY,
    ),
    onCreateCollection: createCollectionAction(GA_HOME_FEED_CATEGORY),
    onWillShareClick: clickOnShareEvent,
    onClickOnBoardingCard: clickOnOnboardingCard,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(EventsBucket);
